// extracted by mini-css-extract-plugin
module.exports = {"stepsSection1Card1":"numbered-steps-section-slice_stepsSection1Card1___S_A3","stepsSection1Card1Hover":"numbered-steps-section-slice_stepsSection1Card1Hover__JWiDn"};